'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_digitalinternship_data_Segments$ProblemSection(eyebrow, title, sub, cards, footer) {
  this.it = null;
  this.iv = null;
  this.iu = null;
  this.is = null;
  this.gy = null;
  this.it = eyebrow;
  this.iv = title;
  this.iu = sub;
  this.is = cards;
  this.gy = footer;
}
export { $c_Lio_intela_sites_digitalinternship_data_Segments$ProblemSection as $c_Lio_intela_sites_digitalinternship_data_Segments$ProblemSection };
$p = $c_Lio_intela_sites_digitalinternship_data_Segments$ProblemSection.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_digitalinternship_data_Segments$ProblemSection;
/** @constructor */
function $h_Lio_intela_sites_digitalinternship_data_Segments$ProblemSection() {
}
export { $h_Lio_intela_sites_digitalinternship_data_Segments$ProblemSection as $h_Lio_intela_sites_digitalinternship_data_Segments$ProblemSection };
$h_Lio_intela_sites_digitalinternship_data_Segments$ProblemSection.prototype = $p;
$p.N = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.s = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().W(this, 854578088, true);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lio_intela_sites_digitalinternship_data_Segments$ProblemSection)) {
    if (((this.it === x$0.it) && (this.iv === x$0.iv))) {
      var x = this.iu;
      var x$2 = x$0.iu;
      var $x_2 = ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$3 = this.is;
      var x$4 = x$0.is;
      var $x_1 = ((x$3 === null) ? (x$4 === null) : x$3.i(x$4));
    } else {
      var $x_1 = false;
    }
    if ($x_1) {
      var x$5 = this.gy;
      var x$6 = x$0.gy;
      return ((x$5 === null) ? (x$6 === null) : x$5.i(x$6));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.t = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().V(this);
});
$p.G = (function() {
  return 5;
});
$p.I = (function() {
  return "ProblemSection";
});
$p.H = (function(n) {
  switch (n) {
    case 0: {
      return this.it;
      break;
    }
    case 1: {
      return this.iv;
      break;
    }
    case 2: {
      return this.iu;
      break;
    }
    case 3: {
      return this.is;
      break;
    }
    case 4: {
      return this.gy;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$ProblemSection(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bF)));
}
export { $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$ProblemSection as $isArrayOf_Lio_intela_sites_digitalinternship_data_Segments$ProblemSection };
var $d_Lio_intela_sites_digitalinternship_data_Segments$ProblemSection = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_digitalinternship_data_Segments$ProblemSection, "io.intela.sites.digitalinternship.data.Segments$ProblemSection", ({
  bF: 1,
  b: 1,
  e: 1,
  a: 1
}));
export { $d_Lio_intela_sites_digitalinternship_data_Segments$ProblemSection as $d_Lio_intela_sites_digitalinternship_data_Segments$ProblemSection };
//# sourceMappingURL=io.intela.sites.digitalinternship.data.-Segments$-Problem-Section.js.map
